/* eslint-disable */
import React, { useEffect, useRef } from 'react';
import { ReactComponent as ActiveSVG } from '../../../../assets/images/check.svg';
import styles from './style.module.scss';
import { useStore } from '../../../../store/store';
import { t } from '@web-solutions/module-localization';

const APP_URL = 'https://app.ravelo.pro';

const WebUpsaleFourth = () => {
  const email = useStore((state) => state.email);
  // const authTokens = useStore((state) => state.authTokens);
  // const authTokensExpiry = useStore((state) => state.authTokensExpiry);
  // const pwaWindowRef = useRef(null);

  // const pwaUrl = getPwaUrlForOnboarding();

  // const hasValidTokens = authTokens && authTokensExpiry && authTokensExpiry > Date.now();
  // console.log(authTokens);
  // console.log(authTokensExpiry);

  // const sendTokensWithRetry = (pwaWindow, attempt = 1) => {
  //   if (!pwaWindow || pwaWindow.closed) {
  //     console.log('PWA окно закрыто');
  //     return;
  //   }

  //   try {
  //     console.log(`🔄 Попытка ${attempt} отправки токенов в ${pwaUrl}`);

  //     pwaWindow.postMessage(
  //       {
  //         type: 'AUTH_TOKENS_FROM_ONBOARDING',
  //         payload: {
  //           accessToken: authTokens.accessToken,
  //           refreshToken: authTokens.refreshToken,
  //           userId: authTokens.userId,
  //           email: email,
  //           timestamp: Date.now(),
  //           source: 'onboarding',
  //           environment: pwaUrl.includes('stage') ? 'stage' : 'prod',
  //         },
  //       },
  //       pwaUrl
  //     );

  //     console.log('✅ Токены отправлены в PWA');
  //     useStore.getState().clearAuthTokens();

  //     // Закрываем текущую вкладку онбординга через 3 секунды
  //     setTimeout(() => {
  //       window.close();
  //     }, 3000);
  //   } catch (error) {
  //     console.warn(`❌ Ошибка при попытке ${attempt}:`, error);

  //     // Пробуем еще раз если не превышен лимит попыток
  //     if (attempt < 5) {
  //       setTimeout(() => sendTokensWithRetry(pwaWindow, attempt + 1), 1000 * attempt);
  //     }
  //   }
  // };

  // useEffect(() => {
  //   if (hasValidTokens) {
  //     console.log('🎯 Начинаем процесс передачи токенов в PWA');
  //     console.log('PWA URL:', pwaUrl);

  //     // Открываем PWA
  //     const pwaWindow = window.open(pwaUrl, '_blank', 'noopener,noreferrer');
  //     pwaWindowRef.current = pwaWindow;

  //     if (!pwaWindow) {
  //       console.error('❌ Не удалось открыть PWA окно');
  //       return;
  //     }

  //     console.log('✅ PWA окно открыто');

  //     // Даем PWA время на загрузку (увеличьте время если нужно)
  //     setTimeout(() => {
  //       sendTokensWithRetry(pwaWindow, 1);
  //     }, 3000); // Увеличено до 3 секунд

  //     // Дополнительные попытки
  //     setTimeout(() => {
  //       if (pwaWindowRef.current) {
  //         sendTokensWithRetry(pwaWindowRef.current, 2);
  //       }
  //     }, 5000);

  //     setTimeout(() => {
  //       if (pwaWindowRef.current) {
  //         sendTokensWithRetry(pwaWindowRef.current, 3);
  //       }
  //     }, 8000);
  //   }
  // }, [hasValidTokens, authTokens, email, pwaUrl]);

  return (
    <div className={styles.container}>
      <main className={styles.main}>
        <div className={styles.content}>
          <h2 className={styles.listHeader}>{t('onboarding.upsale.getStarted')}</h2>
          <p className={styles.description}>{t('onboarding.upsale.access')}</p>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              <ActiveSVG />
              <p>
                {t('onboarding.upsale.download')} <b>Ravelo</b> {t('onboarding.upsale.from')}
              </p>
            </li>
            <li className={styles.listItem}>
              <ActiveSVG />
              <p>
                {t('onboarding.upsale.enterYour')} <b>e-mail:</b>
                <span>{email}</span>
              </p>
            </li>
            <li className={styles.listItem}>
              <ActiveSVG />
              <p>{t('onboarding.upsale.otp')}</p>
            </li>
          </ul>
        </div>
      </main>
      <footer className={styles.footer}>
        <div className={styles.buttons}>
          <a
            className={styles.appLink}
            href={APP_URL}
            target='_blank'
            rel='noopener noreferrer'
          >
            {t('onboarding.upsale.openApp')}
          </a>
        </div>
        <p className={styles.contact}>
          {t('onboarding.upsale.writeUs')}
          <b>support@ravelo.pro</b>
        </p>
      </footer>
    </div>
  );
};

export default WebUpsaleFourth;
